<template>
  <StateSelect v-model="localModel.state"/>
  <div class="d-flex justify-end">
    <v-btn text="Save" @click="submit">
      <v-icon color="green" icon="mdi-checkbox-marked-circle" start></v-icon>
      Ok
    </v-btn>
  </div>
</template>
<script lang="ts" setup>
import StateSelect from "@/components/inputs/StateSelect.vue";
import {Task, State} from "@/types/Order";
import {ref, watch} from "vue";

//eventuell rückmelde datum zuzsätlich
const model = defineModel<Task>()

const localModel = ref<Task>(JSON.parse(JSON.stringify(model.value)));
localModel.value.state = State.beend;

const props = defineProps<{
  onClose?: () => void
  //onSubmit?: (value: Aufgabe) => void
}>()

watch(() => model, (newVal) => {
  localModel.value = JSON.parse(JSON.stringify(newVal))
})

function submit() {
  model.value.state = localModel.value.state;
  props.onClose?.()
}

</script>